import React, { RefObject } from 'react';

export const Moving = (button: RefObject<any>, span: RefObject<any>, dopFunc?: any) => (e: any) => {
  if (dopFunc) {
    dopFunc();
  }

  let Top = button.current?.getBoundingClientRect().y;
  let Left = button.current?.getBoundingClientRect().x;

  if (Top && Left) {
    let relX = e.clientX - Left;
    let relY = e.clientY - Top;

    span.current.style.top = `${relY}px`;
    span.current.style.left = `${relX}px`;
  }
};
